import { render, staticRenderFns } from "./addForm.vue?vue&type=template&id=32af363d&"
import script from "./addForm.vue?vue&type=script&lang=js&"
export * from "./addForm.vue?vue&type=script&lang=js&"
import style0 from "./addForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports